import { render, staticRenderFns } from "./FormDate.vue?vue&type=template&id=13140bd0"
import script from "./FormDate.vue?vue&type=script&lang=js"
export * from "./FormDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports